import React from 'react';
import { Photo } from '../../../../types';
import { PhotoDisplayData } from '../../../../types/PhotoDisplayData';
import { useAdminStore } from '../../../../stores/useAdminStore';
import { InlinePhotoActions } from '../../../admin/InlinePhotoActions';
import { InlinePhotoAudienceToggle } from '../../../admin/InlinePhotoAudienceToggle';

interface PhotoTileFrameProps {
    photo: Photo;
    photoData?: PhotoDisplayData;
    index: number;
    totalPhotos?: number;
    wrapperClassName: string;
    ariaLabel: string;
    onActivate: () => void;
    wrapperStyle?: React.CSSProperties;
    children: React.ReactNode;
}

export const PhotoTileFrame: React.FC<PhotoTileFrameProps> = ({
    photo,
    photoData,
    index,
    totalPhotos,
    wrapperClassName,
    ariaLabel,
    onActivate,
    wrapperStyle,
    children,
}) => {
    const isAdminMode = useAdminStore(s => s.isAdminMode);

    return (
        <div key={index} className={`event-photo-panel hover-zoom ${isAdminMode ? 'admin-active' : ''}`} data-testid="photo-card">
            <div className={photo.caption ? 'image-container has-caption' : 'image-container no-caption'}>
                <div
                    className={wrapperClassName}
                    onClick={onActivate}
                    role="button"
                    tabIndex={0}
                    style={wrapperStyle}
                    aria-label={ariaLabel}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onActivate();
                        }
                    }}
                >
                    {children}
                </div>
                {photo.caption && <p className="image-caption">{photo.caption}</p>}
                {/* Negative ids come from the static fallback and have no server row. */}
                {isAdminMode && photoData && photoData.id > 0 && (
                    <>
                        <InlinePhotoAudienceToggle photo={photoData} />
                        <InlinePhotoActions
                            photo={photoData}
                            photoIndex={index}
                            totalPhotos={totalPhotos || 0}
                        />
                    </>
                )}
            </div>
        </div>
    );
};
